<template>
	<tq-on-top-container  class="TQ_fullScreen">
		<div class="TQ_direction_ltr TQ_box_shadow TQ_fullScreen TQ_bg_gray3 TQ_width_100p" slot="body">
			<div class="lc_myBar TQ_verticalAlignMiddle"
			     :style="{'width' : format_percentage(p_progress_n), 'height' : ps_lineHeight_s, background: co_pointsColor_fs}"></div>
		</div>
		<div class="text" slot="middle" v-if="pf_showProgressNum_b">
			{{format_percentage(p_progress_n)}}
		</div>
		<slot slot="middle"></slot>
	</tq-on-top-container>
</template>

<script>
    import {format_percentage} from "../../../functions/src/shareCode/Share_S_Format";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import {gv_strings} from "../../scripts/S_GlobalVar";

    export default {
        name: "TqProgressBar",
        components: {TqOnTopContainer},
        props:{
            p_progress_n:{
                require: true,
                type: Number
            },
	        pf_showProgressNum_b:{
                type: Boolean,
		        default: true
	        },
	        ps_lineHeight_s:{
                type: String,
                default: '30px'
	        }

        },
        data(){
            return {
                format_percentage : format_percentage
            }
        },
	    computed:{
            co_pointsColor_fs(){
                if(this.p_progress_n < 0.4){
                    return 'var(--color-red)'
                }else if(this.p_progress_n < 0.8){
                    return 'var(--color-gold)'
                }else{
                    return 'var(--color-green)'
                }
            }
	    }
    }
</script>

<style scoped>
	.lc_myBar {
		line-height: 30px;
		text-align: center;
		color: white;
	}
</style>